module.exports = __webpack_public_path__ + "img/recall.697de887.svg";